export default "__VITE_ASSET__BvK2xpew__"